export const docs = {
  config: {
    home: "https://trigger.dev/docs/v3/trigger-config",
    esm: "https://trigger.dev/docs/v3/trigger-config#esm-only-packages",
    prisma: "https://trigger.dev/docs/v3/trigger-config#prisma-and-other-generators",
    additionalPackages: "https://trigger.dev/docs/v3/trigger-config#prisma-and-other-generators",
  },
};

export const getInTouch = "https://trigger.dev/contact";
